import { getStorage } from '@picsart/growth-rc/services/browserStorage';

const REACT_APP_IMAGE_EXTENSIONS = 'jpeg jpg png';
const REACT_APP_BUGSNAG = '0';

const localConfigs = {
  bugSnag: Boolean(Number(REACT_APP_BUGSNAG)),
  analytics: process.env.REACT_APP_ANALYTICS || 'gtag',
  REGEXP_FOR_IMAGES: new RegExp(
    `\\.(${REACT_APP_IMAGE_EXTENSIONS?.replace(/\s/g, '|')})(\\\\?.*)$`,
  ),
  enableRedirections: Boolean(Number(process.env.REACT_APP_ENABLE_REDIRECTIONS)),
};

type ConfigsType = typeof localConfigs;

let devToolsConfigs: ConfigsType;
try {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  devToolsConfigs = (JSON.parse(getStorage('buildConfigs', false)!) || {}) as ConfigsType;
} catch (e) {
  devToolsConfigs = {} as ConfigsType;
}

export const configs = (Object.keys(localConfigs) as Array<keyof ConfigsType>).reduce(
  (computedConfig, key) => ({
    ...computedConfig,
    [key]: (key in devToolsConfigs ? devToolsConfigs : localConfigs)[key],
  }),
  {} as ConfigsType,
);

export default localConfigs;
